import { GameEntity } from '@okletsplay/core';
import { useCreateBaseTournamentForm } from '../use-base-tournament-form';
import { createBaseKnockoutTournamentSchema } from '../use-base-tournament-form/create-base-knockout-tournament-schema';

export const useCreateEvIoTournamentForm = (game: GameEntity) => {
  const startedAt = new Date();

  return useCreateBaseTournamentForm(game, {
    createStaticSchemaFunction: createBaseKnockoutTournamentSchema,
    additionalDefaultValues: {
      subMatchesSettings: [],
      startedAt,
    },
  });
};
